import api from 'common/api';
import {
  SearchStatusMasterRequest,
  DetailStatusMasterRequest,
  UpdateStatusMasterRequest,
  DeleteStatusMasterRequest,
} from 'api-types/src/types/status-master'

export const getStatusAPI = (params: SearchStatusMasterRequest) => api.get('/status-master/list', params);

export const getStatusDetailAPI = (params: DetailStatusMasterRequest)  => api.get('/status-master/detail', params);

export const addStatusAPI = (params: UpdateStatusMasterRequest) => api.post('/status-master', params);

export const updateStatusAPI = (params: UpdateStatusMasterRequest) => api.put('/status-master', params);

export const deleteStatusAPI = (params: DeleteStatusMasterRequest) => api.put('/status-master/delete', params);

export const DOWNLOAD_EXCEL_STATUS_MAST = '/status-master/list';
